module.exports = __webpack_public_path__ + "static/img/kurogokio.7e2596c.jpg";